import React from 'react';
import { Button, Modal, message } from 'antd';
import AvailabilityRows from '../AvailabilityRows';
import { AddAction, SmallP } from '../../../../../GarageAllocation/styled';
import { newGarageRow } from '../../logic/prefillAvailability';
import ValidationErrors from '../ValidationErrors';
import ModalLoadingOverlay from '$app/shared/components/ModalLoadingOverlay';

const AvailabilitySelectionModal = ({
  visible,
  setVisible,
  sendRescheduleProposal,
  garages,
  rescheduleAvailabilityRows,
  setRescheduleAvailabilityRows,
  errors,
  availabilitySubmitted,
}) => {
  const handleCancel = () => {
    message.info('Reschedule options saved as draft');
    setVisible(false);
  };

  const addGarageRow = () => setRescheduleAvailabilityRows([...rescheduleAvailabilityRows, newGarageRow()]);

  const AddGarageButton = () => (
    <AddAction src="icon-add-circle-1" onClick={addGarageRow}>
      <SmallP>Add another garage</SmallP>
    </AddAction>
  );

  const isLoading = !garages || availabilitySubmitted;

  return (
    <Modal
      visible={visible}
      title="Select available dates for the customer"
      onCancel={handleCancel}
      width="850px"
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={sendRescheduleProposal}>
          Send reschedule proposal
        </Button>,
      ]}
    >
      {isLoading && <ModalLoadingOverlay />}
      <p>
        Customer will receive a schedule with all the dates given to choose from. Please give the customer as
        many dates as possible.
      </p>
      <p>
        <b>The minimum required is five dates.</b>
      </p>
      <br />

      <AvailabilityRows
        garages={garages}
        setRescheduleAvailabilityRows={setRescheduleAvailabilityRows}
        rescheduleAvailabilityRows={rescheduleAvailabilityRows}
      />

      <ValidationErrors errors={errors} />

      <AddGarageButton />
    </Modal>
  );
};

export default AvailabilitySelectionModal;
